export default function stores_map(state = null, action) {
    switch (action.type) {
        case 'stores_map_SET':
            return action.payload
        default:
            return state
    }
} 